<script setup>
const props = defineProps({
  fillColor: { type: String, default: '#fff' },
})
</script>

<template>
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M3.59998 6.00156C3.59998 4.67608 4.67449 3.60156 5.99998 3.60156H18C19.3255 3.60156 20.4 4.67608 20.4 6.00156V15.6016C20.4 16.927 19.3255 18.0016 18 18.0016H15.3369L15.4836 18.5881L16.4485 19.553C16.7917 19.8962 16.8944 20.4124 16.7087 20.8608C16.5229 21.3092 16.0854 21.6016 15.6 21.6016H8.40001C7.91466 21.6016 7.47709 21.3092 7.29136 20.8608C7.10562 20.4124 7.20828 19.8962 7.55148 19.553L8.51645 18.5881L8.66308 18.0016H5.99998C4.67449 18.0016 3.59998 16.927 3.59998 15.6016V6.00156ZM10.5255 14.4016C10.5079 14.4012 10.4902 14.4012 10.4727 14.4016H5.99998V6.00156H18V14.4016H13.5273C13.5098 14.4012 13.4922 14.4012 13.4745 14.4016H10.5255Z"
      :fill="fillColor"
    />
  </svg>
</template>
